import { mapGetters } from "vuex"
import moment from "moment-timezone"
import { ElMessageBox } from "element-plus";

export default {
  computed: {
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("auth", ["getUserAllowedLabs", "getUserPrimaryLabId"]),
    isBillingUser() {
      const billingUserTypes = [
        "AR_LEAD",
        "AR_EXECUTIVE",
        "CP_LEAD",
        "CODING_LEAD",
        "CODING_EXECUTIVE",
        "POSTING_EXECUTIVE",
        "SR_FTE",
        "BILLING_REPRESENTATIVE"
      ];

      if (this.getAuthenticatedUser && billingUserTypes.includes(this.getAuthenticatedUser.user_type)) {
        return false;
      }
      return true;
    },
    isSuperAdmin() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type &&
        this.getAuthenticatedUser.user_type == "LAB_SUPER_ADMIN"
      ) {
        return true
      }
      return false
    },
    // Potential Payers (Medical Group Rules) is viewable by all billing users
    // and lab admins. Adding new payers is restricted separately (see
    // canAddPotentialPayer / the two allowed usernames).
    canViewPotentialPayers() {
      const user = this.getAuthenticatedUser;
      if (!user) return false;
      const viewableUserTypes = [
        // billing users
        "AR_LEAD",
        "AR_EXECUTIVE",
        "BILLING_REPRESENTATIVE",
        "CP_LEAD",
        "CODING_LEAD",
        "CODING_EXECUTIVE",
        "POSTING_EXECUTIVE",
        "SR_FTE",
        // lab admins
        "LAB_ADMIN",
        "LAB_SUPER_ADMIN",
      ];
      const allowedUsernames = ["sathwikb", "anilurs"];
      return (
        viewableUserTypes.includes(user.user_type) ||
        allowedUsernames.includes(user.username)
      );
    },
    isHospitalUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "HOSPITAL_MARKETING_MANAGER"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    isFacilityUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "QC_MANAGER",
          "BILLING_REPRESENTATIVE",
          "AR_LEAD",
          "AR_EXECUTIVE",
          "CP_LEAD",
          "CODING_LEAD",
          "CODING_EXECUTIVE",
          "POSTING_EXECUTIVE",
          "SR_FTE",
          "SALES_DIRECTOR"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    isLabUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "LAB_ADMIN",
          "LAB_MANAGER",
          "BILLING_REPRESENTATIVE",
          "LAB_DATA_ASSISTANT",
          "LAB_SUPER_ADMIN",
          "LAB_DATA_ADMIN"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
  },
  methods: {
    changetocaptila(str) {
      var splitStr = str.toLowerCase().split(" ")
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
      }
      return splitStr.join(" ")
    },
    convertToUppercase(str) {
      return str ? str.toUpperCase() : "--";
    },   
    allowAlphaNumericSpace(e) {
      var code = "charCode" in e ? e.charCode : e.keyCode
      if (
        !(code == 32) && // space
        !(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123)
      ) {
        // lower alpha (a-z)
        e.preventDefault()
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z\s]+$/.test(char)) return true // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    isInactiveStatus(data) {
      return data.status && data.status == "INACTIVE" ? true : false
    },
    momentWithTimezone: function (
      value,
      format = "MM-DD-YYYY hh:mm A",
      timezone
    ) {
      if (!value) return "";
      const timeZone = timezone ?? "America/New_York";
      return moment(value).tz(timeZone).format(format);
    },
    momentWithTimezoneTime: function (
      value,
      format = "MM-DD-YYYY hh:mm A",
      timezone
    ) {
      if (!value) return "";
      const timeZone = timezone ?? "America/New_York";
      return moment(value).tz(timeZone).format(format);
    },
    convertToLabUTC(dateTime, end_date = false) {
      if (!dateTime) return
      let clientTz = moment.tz.guess()

      let labTimezone = this.getProfileDat?.lab?.timezone || "America/New_York"
      let clientTime = moment(dateTime).tz(clientTz)

      let h = clientTime.hour()
      let mn = clientTime.minutes()
      let s = clientTime.seconds()

      let y = clientTime.year()
      let d = clientTime.date()
      let m = clientTime.month()
      if (end_date) {
        return moment()
          .tz(labTimezone)
          .set({
            hours: h,
            minutes: mn,
            year: y,
            seconds: s,
            date: d,
            month: m,
          })
          .utc()
          .endOf("day")
          .format()
      } else {
        return moment()
          .tz(labTimezone)
          .set({
            hours: h,
            minutes: mn,
            year: y,
            seconds: s,
            date: d,
            month: m,
          })
          .utc()
          .format()
      }
    },
    convertLabUTCToClient(dateTime) {
      let labTimezone = this.getProfileData?.lab?.timezone || "America/New_York"
      return new Date(dateTime).toLocaleString("en-us", {
        timeZone: labTimezone,
      })
    },
    getPatientNameByInfo(patientInfo) {
      if (!patientInfo) return
      let name = []
      if (patientInfo.first_name) {
        name.push(patientInfo.first_name)
      }
      if (patientInfo.middle_name) {
        name.push(patientInfo.middle_name)
      }
      if (patientInfo.last_name) {
        name.push(patientInfo.last_name)
      }
      return name.join(" ")
    },
    copyTitle(titleData) {
      const title = titleData
      navigator.clipboard
        .writeText(title)
        .then(() => {
          console.log("Title copied to clipboard:", title)
        })
        .catch((error) => {
          console.error("Failed to copy title to clipboard:", error)
        })
    },
    formatDate(date, format = "MM-DD-YYYY") {
      if (date) {
        return moment.utc(date).format(format);
      } else {
        return "--";
      }
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("err")[0];
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
  },
}
